"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  WINDOWS: 'WINDOWS',
  MACOS: 'MACOS',
  Linux: 'Linux',
  ANDROID: 'ANDROID',
  IOS: 'IOS'
};
exports.default = _default;
module.exports = exports.default;